import * as E from 'fp-ts/Either';
import * as Opt from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import { failure } from 'io-ts/PathReporter';
export const decodeWith = (codec, thing, printErrors = false) => pipe(codec.decode(thing), E.getOrElseW((errors) => {
    if (printErrors) {
        console.error(`Failed to decode with codec ${codec.name}:\n`);
        console.error(failure(errors).join('\n'));
    }
    return undefined;
}));
export const decodeThrowing = (codec, thing) => {
    const result = codec.decode(thing);
    if (E.isLeft(result)) {
        throw new Error(`Failed to decode using ${codec.name}: ${failure(result.left).join('\n')}`);
    }
    return result.right;
};
export const decodeOption = (codec, item) => pipe(codec.decode(item), E.fold(() => Opt.none, val => Opt.some(val)));
export default decodeWith;
